import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("venturekhoj_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// R217 — Global wallet paywall. When any endpoint returns 402 with a
// structured `insufficient_balance` detail, broadcast an event so the
// top-level WalletTopUpManager can open the top-up dialog. The original
// promise still rejects so callers can stop their own loading states.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 402 && detail && typeof detail === "object" && detail.error === "insufficient_balance") {
      try {
        window.dispatchEvent(new CustomEvent("vk:wallet-insufficient", { detail }));
      } catch (_) { /* noop */ }
    }
    return Promise.reject(err);
  },
);

export function extractError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  if (typeof detail === "object" && detail.message) return detail.message;
  return String(detail);
}

export default api;
